import { lazily } from 'react-lazily'

import { wrapSuspense } from '../../atoms/placeholders/Suspense'

export { StyledTable, StyledTableCell, StyledTableCompress, StyledTableHeader, StyledTableRow } from './Table.styles'

const { Table: RawTable } = lazily(() => import('./Table'))
const Table = wrapSuspense<typeof RawTable>(RawTable)
export { Table }
